import { Col, Form, Input, Row, Select, Space } from "antd";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { GET_USERS, GET_USERS1 } from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import httpService from "services/httpService";
import styled from "styled-components";
import { CommonButton } from "components/Common/ButtonCommon";
import ModalCommon from "components/Common/ModalCommon";
import { ModalBody, ModalFooter } from "reactstrap";
import { CommonInputt, CommonLabel } from "components/Common/inputCommon";
import { language_vn } from "helpers/language_vn";
import Spacer from "components/Common/Spacing";

export default function NewAccountAdmin() {
  const { id } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [pass, setPass] = useState({
    pass: "",
    retypePass: "",
  });
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    getUserDetail();
  }, [id]);

  const getUserDetail = async () => {
    if (!id) return;

    const res = await httpService.get(`${GET_USERS}/${id}`);

    if (!res) {
      history.replace("/Account Admin");
      toastrErrorAlert("Account Admin not found!");
      return;
    }

    form.setFieldsValue({
      ...res,
    });
  };

  const onSubmit = async values => {
    const { confirm, ...rest } = values;
    const body = {
      ...rest,
      userType: "internal",
    };
    if (id) {
      await httpService.put(`${GET_USERS}/${id}`, body);
      toastrSuccessAlert("Cập nhật tài khoản thành công!");
      return;
    }
    try {
      const res = await httpService.post(GET_USERS, body);
      toastrSuccessAlert("Thêm tài khoản thành công!");
      history.replace(`/account-admin/${res.objectId}`);
    } catch (error) {
      if (error.response?.data?.code == 202) {
        toastrErrorAlert(
          "Tên đăng nhập bạn vừa dùng đã tồn tại. Vui lòng nhập một tên đăng nhập khác."
        );
      }
    }
  };

  const onResetPassword = async () => {
    try {
      if (!pass.pass || !pass.retypePass) {
        toastrErrorAlert(
          !pass.pass ? "Vui lòng nhập mật khẩu" : "Vui lòng nhập lại mật khẩu"
        );
        return;
      }

      if (pass.pass !== pass.retypePass) {
        toastrErrorAlert("Mật khẩu mới và nhập lại mật khẩu phải giống nhau!");
        return;
      }
      const res = await httpService.put(
        GET_USERS1 + `/${id}`,
        {
          objectId: id,
          password: pass.pass,
        },
        {
          headers: {
            "X-Parse-Master-Key": "LASDK106JKHR87SDFJSDHF0DFHASFDF",
          },
        }
      );
      setToggle(false);
      if (res?.updatedAt) {
        toastrSuccessAlert("Đặt lại mật khẩu thành công!!");
        return;
      }
    } catch (error) {
      toastrErrorAlert(language_vn.error);
    }
  };

  return (
    <div className="page-content">
      <Form
        name="dynamic_form_nest_item"
        onFinish={onSubmit}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <HeaderCreateItem title={"Training Template"}>
          <div className="flex-grow-1 " />
          <CommonButton level={0} htmlType="submit" className="mr-2">
            Lưu
          </CommonButton>
          {id && (
            <>
              <Spacer size={10} />
              <CommonButton
                level={1}
                type="button"
                onClick={() => {
                  setToggle(true);
                }}
              >
                Đặt lại mật khẩu
              </CommonButton>
            </>
          )}
        </HeaderCreateItem>
        <Row gutter={24}>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label="Tên đăng nhập"
              name="username"
              rules={[
                { required: true, message: "Vui lòng nhập tên đăng nhập!" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label="Họ và tên"
              name="fullName"
              rules={[{ required: true, message: "Vui lòng nhập họ và tên!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label="Màn hình được phép truy cập"
              name="screens"
              rules={[{ required: true, message: "Vui lòng chọn màn hình!" }]}
            >
              <Select
                mode="multiple"
                options={[
                  {
                    label: "Tài khoản user",
                    value: "Tài khoản user",
                  },
                  {
                    label: "Tài khoản QTV",
                    value: "Tài khoản QTV",
                  },
                  { label: "Lịch sử thi", value: "Lịch sử thi" },
                  { label: "Chủ đề", value: "Chủ đề" },
                  { label: "Câu hỏi", value: "Câu hỏi" },
                  { label: "Logic trộn đề", value: "Logic trộn đề" },
                  { label: "Lịch sử đăng nhập", value: "Lịch sử đăng nhập" },
                  { label: "CT huấn luyện", value: "CT huấn luyện" },
                  { label: "Sản phẩm công ty", value: "Sản phẩm công ty" },
                  { label: "Chi tiết sản phẩm", value: "Chi tiết sản phẩm" },
                ]}
              />
            </Form.Item>
          </Col>
          {!id && (
            <>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Vui lòng nhập mật khẩu!" },
                  ]}
                >
                  <Input.Password autoComplete={"new-password"} />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  name="confirm"
                  label="Confirm Password"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập mật khẩu!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("2 mật khẩu bạn nhập không trùng khớp!")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
      </Form>

      <ModalCommon
        modalTitle="Đặt lại mật khẩu"
        isShowModal={toggle}
        onClose={() => {
          setToggle(prev => !prev);
        }}
      >
        <ModalBody>
          <div style={{ margin: "0 12px" }}>
            <CommonLabel>Nhập mật khẩu mới</CommonLabel>
            <CommonInputt
              className="form-control"
              type="password"
              onChange={e => {
                setPass({
                  ...pass,
                  pass: e.target.value,
                });
              }}
            />
            <CommonLabel>Nhập lại mật khẩu mới</CommonLabel>
            <CommonInputt
              className="form-control"
              type="password"
              onChange={e => {
                setPass({
                  ...pass,
                  retypePass: e.target.value,
                });
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <CommonButton
            level={0}
            onClick={() => {
              setToggle(prev => !prev);
            }}
          >
            Huỷ
          </CommonButton>
          <CommonButton level={3} onClick={onResetPassword}>
            Đồng ý
          </CommonButton>
        </ModalFooter>
      </ModalCommon>
    </div>
  );
}

const SpaceStyled = styled(Space)`
  .ant-space-item {
    width: 100%;
  }
`;
